export default "__VITE_ASSET__BM6mD4$J__"